// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    v2PublicGetCurrencies (params?: {}): Promise<Dict>;
    v2PublicGetCurrenciesCrypto (params?: {}): Promise<Dict>;
    v2PublicGetTime (params?: {}): Promise<Dict>;
    v2PublicGetExchangeRates (params?: {}): Promise<Dict>;
    v2PublicGetUsersUserId (params?: {}): Promise<Dict>;
    v2PublicGetPricesSymbolBuy (params?: {}): Promise<Dict>;
    v2PublicGetPricesSymbolSell (params?: {}): Promise<Dict>;
    v2PublicGetPricesSymbolSpot (params?: {}): Promise<Dict>;
    v2PrivateGetAccounts (params?: {}): Promise<Dict>;
    v2PrivateGetAccountsAccountId (params?: {}): Promise<Dict>;
    v2PrivateGetAccountsAccountIdAddresses (params?: {}): Promise<Dict>;
    v2PrivateGetAccountsAccountIdAddressesAddressId (params?: {}): Promise<Dict>;
    v2PrivateGetAccountsAccountIdAddressesAddressIdTransactions (params?: {}): Promise<Dict>;
    v2PrivateGetAccountsAccountIdTransactions (params?: {}): Promise<Dict>;
    v2PrivateGetAccountsAccountIdTransactionsTransactionId (params?: {}): Promise<Dict>;
    v2PrivateGetAccountsAccountIdBuys (params?: {}): Promise<Dict>;
    v2PrivateGetAccountsAccountIdBuysBuyId (params?: {}): Promise<Dict>;
    v2PrivateGetAccountsAccountIdSells (params?: {}): Promise<Dict>;
    v2PrivateGetAccountsAccountIdSellsSellId (params?: {}): Promise<Dict>;
    v2PrivateGetAccountsAccountIdDeposits (params?: {}): Promise<Dict>;
    v2PrivateGetAccountsAccountIdDepositsDepositId (params?: {}): Promise<Dict>;
    v2PrivateGetAccountsAccountIdWithdrawals (params?: {}): Promise<Dict>;
    v2PrivateGetAccountsAccountIdWithdrawalsWithdrawalId (params?: {}): Promise<Dict>;
    v2PrivateGetPaymentMethods (params?: {}): Promise<Dict>;
    v2PrivateGetPaymentMethodsPaymentMethodId (params?: {}): Promise<Dict>;
    v2PrivateGetUser (params?: {}): Promise<Dict>;
    v2PrivateGetUserAuth (params?: {}): Promise<Dict>;
    v2PrivateGetSubscriptionsCoinbaseOne (params?: {}): Promise<Dict>;
    v2PrivatePostAccounts (params?: {}): Promise<Dict>;
    v2PrivatePostAccountsAccountIdPrimary (params?: {}): Promise<Dict>;
    v2PrivatePostAccountsAccountIdAddresses (params?: {}): Promise<Dict>;
    v2PrivatePostAccountsAccountIdTransactions (params?: {}): Promise<Dict>;
    v2PrivatePostAccountsAccountIdTransactionsTransactionIdComplete (params?: {}): Promise<Dict>;
    v2PrivatePostAccountsAccountIdTransactionsTransactionIdResend (params?: {}): Promise<Dict>;
    v2PrivatePostAccountsAccountIdBuys (params?: {}): Promise<Dict>;
    v2PrivatePostAccountsAccountIdBuysBuyIdCommit (params?: {}): Promise<Dict>;
    v2PrivatePostAccountsAccountIdSells (params?: {}): Promise<Dict>;
    v2PrivatePostAccountsAccountIdSellsSellIdCommit (params?: {}): Promise<Dict>;
    v2PrivatePostAccountsAccountIdDeposits (params?: {}): Promise<Dict>;
    v2PrivatePostAccountsAccountIdDepositsDepositIdCommit (params?: {}): Promise<Dict>;
    v2PrivatePostAccountsAccountIdWithdrawals (params?: {}): Promise<Dict>;
    v2PrivatePostAccountsAccountIdWithdrawalsWithdrawalIdCommit (params?: {}): Promise<Dict>;
    v2PrivatePutAccountsAccountId (params?: {}): Promise<Dict>;
    v2PrivatePutUser (params?: {}): Promise<Dict>;
    v2PrivateDeleteAccountsId (params?: {}): Promise<Dict>;
    v2PrivateDeleteAccountsAccountIdTransactionsTransactionId (params?: {}): Promise<Dict>;
    v3PublicGetBrokerageTime (params?: {}): Promise<Dict>;
    v3PublicGetBrokerageMarketProductBook (params?: {}): Promise<Dict>;
    v3PublicGetBrokerageMarketProducts (params?: {}): Promise<Dict>;
    v3PublicGetBrokerageMarketProductsProductId (params?: {}): Promise<Dict>;
    v3PublicGetBrokerageMarketProductsProductIdCandles (params?: {}): Promise<Dict>;
    v3PublicGetBrokerageMarketProductsProductIdTicker (params?: {}): Promise<Dict>;
    v3PrivateGetBrokerageAccounts (params?: {}): Promise<Dict>;
    v3PrivateGetBrokerageAccountsAccountUuid (params?: {}): Promise<Dict>;
    v3PrivateGetBrokerageOrdersHistoricalBatch (params?: {}): Promise<Dict>;
    v3PrivateGetBrokerageOrdersHistoricalFills (params?: {}): Promise<Dict>;
    v3PrivateGetBrokerageOrdersHistoricalOrderId (params?: {}): Promise<Dict>;
    v3PrivateGetBrokerageProducts (params?: {}): Promise<Dict>;
    v3PrivateGetBrokerageProductsProductId (params?: {}): Promise<Dict>;
    v3PrivateGetBrokerageProductsProductIdCandles (params?: {}): Promise<Dict>;
    v3PrivateGetBrokerageProductsProductIdTicker (params?: {}): Promise<Dict>;
    v3PrivateGetBrokerageBestBidAsk (params?: {}): Promise<Dict>;
    v3PrivateGetBrokerageProductBook (params?: {}): Promise<Dict>;
    v3PrivateGetBrokerageTransactionSummary (params?: {}): Promise<Dict>;
    v3PrivateGetBrokeragePortfolios (params?: {}): Promise<Dict>;
    v3PrivateGetBrokeragePortfoliosPortfolioUuid (params?: {}): Promise<Dict>;
    v3PrivateGetBrokerageConvertTradeTradeId (params?: {}): Promise<Dict>;
    v3PrivateGetBrokerageCfmBalanceSummary (params?: {}): Promise<Dict>;
    v3PrivateGetBrokerageCfmPositions (params?: {}): Promise<Dict>;
    v3PrivateGetBrokerageCfmPositionsProductId (params?: {}): Promise<Dict>;
    v3PrivateGetBrokerageCfmSweeps (params?: {}): Promise<Dict>;
    v3PrivateGetBrokerageCfmIntradayCurrentMarginWindow (params?: {}): Promise<Dict>;
    v3PrivateGetBrokerageCfmIntradayMarginSetting (params?: {}): Promise<Dict>;
    v3PrivateGetBrokerageIntxBalancesPortfolioUuid (params?: {}): Promise<Dict>;
    v3PrivateGetBrokerageIntxPortfolioPortfolioUuid (params?: {}): Promise<Dict>;
    v3PrivateGetBrokerageIntxPositionsPortfolioUuid (params?: {}): Promise<Dict>;
    v3PrivateGetBrokerageIntxPositionsPortfolioUuidSymbol (params?: {}): Promise<Dict>;
    v3PrivateGetBrokeragePaymentMethods (params?: {}): Promise<Dict>;
    v3PrivateGetBrokeragePaymentMethodsPaymentMethodId (params?: {}): Promise<Dict>;
    v3PrivateGetBrokerageKeyPermissions (params?: {}): Promise<Dict>;
    v3PrivatePostBrokerageOrders (params?: {}): Promise<Dict>;
    v3PrivatePostBrokerageOrdersBatchCancel (params?: {}): Promise<Dict>;
    v3PrivatePostBrokerageOrdersEdit (params?: {}): Promise<Dict>;
    v3PrivatePostBrokerageOrdersEditPreview (params?: {}): Promise<Dict>;
    v3PrivatePostBrokerageOrdersPreview (params?: {}): Promise<Dict>;
    v3PrivatePostBrokeragePortfolios (params?: {}): Promise<Dict>;
    v3PrivatePostBrokeragePortfoliosMoveFunds (params?: {}): Promise<Dict>;
    v3PrivatePostBrokerageConvertQuote (params?: {}): Promise<Dict>;
    v3PrivatePostBrokerageConvertTradeTradeId (params?: {}): Promise<Dict>;
    v3PrivatePostBrokerageCfmSweepsSchedule (params?: {}): Promise<Dict>;
    v3PrivatePostBrokerageCfmIntradayMarginSetting (params?: {}): Promise<Dict>;
    v3PrivatePostBrokerageIntxAllocate (params?: {}): Promise<Dict>;
    v3PrivatePostBrokerageIntxMultiAssetCollateral (params?: {}): Promise<Dict>;
    v3PrivatePostBrokerageOrdersClosePosition (params?: {}): Promise<Dict>;
    v3PrivatePutBrokeragePortfoliosPortfolioUuid (params?: {}): Promise<Dict>;
    v3PrivateDeleteBrokeragePortfoliosPortfolioUuid (params?: {}): Promise<Dict>;
    v3PrivateDeleteBrokerageCfmSweeps (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
